import axios from "axios";

const ShopifyCreateMultipassToken = async (email) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_BACKEND_API_URL}/multipass`,
      method: "POST",
      data: {
        email,
        return_to: `https://${process.env.REACT_APP_SHOP_URL}/pages/choose-your-style`,
      },
    });
    return response.data.token ? response.data.token : null;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyCreateMultipassToken;
